<template>
  <div>
    <FlatDealState class="mr-1" :state="creative.deal_status" />
    <template v-if="canManageDeal">
      <PossibleActionButton
        v-for="event in dealActions"
        :key="event"
        :event="event"
        :state="''"
        @invoke="manageDeal"
      />
    </template>
  </div>
</template>

<script lang="ts">
import { defineComponent, computed, ref, watch } from 'vue'
import { FlatDealStates } from '@/api/types'
import { useFlatDealsStore } from '@/apps/traforama/store/flatDeals'
import { useCreativesStore } from '@/apps/traforama/store/creatives'
import PossibleActionButton from '@/apps/traforama/components/PossibleActionButton.vue'
import { ICreativeAttributes } from '@/api/creatives'
import { ElMessage } from 'element-plus'
import FlatDealState from './FlatDealState.vue'

export default defineComponent({
  name: 'FlatDealActions',
  components: {
    FlatDealState,
    PossibleActionButton
  },
  props: {
    modelValue: {
      type: Object,
      default: () => {}
    }
  },
  setup(props) {
    const creativesStore = useCreativesStore()
    const flatDealsStore = useFlatDealsStore()
    const creative = ref<ICreativeAttributes>({
      ...props.modelValue
    } as ICreativeAttributes)
    const dealActions = ref(['manager_approve', 'reject_deal'])

    const canManageDeal = computed(() => {
      return (
        creative.value?.deal_status === FlatDealStates.AwaitingManagerReview
      )
    })

    const manageDeal = async (event: string, reason?: string) => {
      flatDealsStore
        .ChangeDealState(creative.value.campaign_id, event, reason)
        .then(() => {
          ElMessage.success({
            message: 'Deal state has been changed.',
            type: 'success'
          })
          if (creative.value.id)
            creativesStore.FetchItem(creative.value.id.toString())
        })
        .catch(() => {
          ElMessage.success({
            message: 'Unable to change deal state',
            type: 'error'
          })
        })
    }

    watch(
      (_: any) => props.modelValue,
      (val: any) => {
        creative.value = val
      }
    )

    return { canManageDeal, manageDeal, dealActions, creative }
  }
})
</script>
<style lang="scss" scoped>
.el-tag {
  border: none !important;
}
.el-button--mini {
  padding: 2px 10px;
}
</style>
